import { useContext, useMemo } from 'react'

import Cookies from 'js-cookie'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { API_DATE, getTimezoneLessMoment } from '../../../utils/momentjs'
import MonthTitle from '../../../Components/MACCS/InternshipsManager/MonthTitle'
import { COLUMNS_INFO_COUNT, DEFAULT_NUMBER_OF_WEEKS, YEAR_AND_MONTH_FORMAT } from '../../../Components/shared/InternshipsManager/utils/constants'
import AssistantMenu from '../ShiftsManager/AssistantMenu'
import MaccsInternshipCard from './MaccsInternshipCard'
import DateCell from '../../../Components/shared/InternshipsManager/DateCell/DateCell'
import Loading from '../../../Components/shared/Loading'
import { MaccsInternshipsContext } from '../../../Providers/MaccsInternshipsProvider'
import MaccsStatesSelector from './MaccsStatesSelector'

const CalendarTable = ({ internships, loading, currentDate, refresh, onDuplicate, onDelete, onStateChange }) => {
  const { setSelectedAssistant, setInternshipInfo, setHighlightedIndexes } = useContext(MaccsInternshipsContext)

  const t = useSelector(selectTranslate)
  const today = moment()

  const height = useMemo(() => {
    return `calc(100vh - ${Cookies.get('switch_user_id') ? '182px' : '141px'})`
  }, [Cookies.get('switch_user_id')])

  const dates = useMemo(() => {
    const dates = []

    for (let i = 0; i < 12; i++) {
      const startDate = currentDate.clone().add(i, 'month').startOf('month')
      const endDate = currentDate.clone().add(i, 'month').endOf('month')

      dates.push({ startDate, endDate })
    }

    return dates
  }, [currentDate.format(API_DATE)])

  return (
    <div className='internship-manager-table' style={{ height }}>
      {!loading && (
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={{ width: '400px', zIndex: 100, minWidth: '400px', textAlign: 'center', backgroundColor: 'white' }}>
                {t('Assistant')} - {t('Working regime')}<br />
                {t('Institution')} - {t('Speciality')}
              </th>
              {dates.map((period, index) => (
                <MonthTitle
                  key={period.startDate.format(YEAR_AND_MONTH_FORMAT)}
                  startDate={period.startDate}
                  endDate={period.endDate}
                  index={index}
                  isCurrentMonth={period.startDate <= today && period.endDate >= today}
                />
              ))}
            </tr>
          </thead>
          <tbody>
            {internships.length > 0 && (
              internships.map((i, index) => {
                const internshipPeriod = []
                let skipPeriod = false
                const startDate = getTimezoneLessMoment(i.startDate)
                const endDate = getTimezoneLessMoment(i.endDate)
                const bornedStartDate = startDate.clone().startOf('month')
                const bornedEndDate = endDate.clone().endOf('month')

                for (let j = 0; j < dates.length; j++) {
                  const props = {
                    key: i.id + '_' + dates[j].startDate.format(YEAR_AND_MONTH_FORMAT),
                    colSpan: 1
                  }
                  let content = null
                  const currentJ = j
                  const period = dates[j]

                  if (!skipPeriod && (period.startDate >= bornedStartDate && period.endDate <= bornedEndDate)) {
                    props.colSpan = bornedEndDate.diff(period.startDate, 'months') + 1
                    skipPeriod = true
                    let className = ''

                    if (dates[0].startDate < startDate) {
                      className += ' internship-start'
                    }

                    if (dates[dates.length - 1].endDate > endDate) {
                      className += ' internship-end'
                    }

                    j += props.colSpan - 1
                    content = (<DateCell className={className} internship={i} startDate={startDate} endDate={endDate} placement='top' />)
                    props.onMouseEnter = () => setHighlightedIndexes({ start: currentJ, end: j })
                    props.onMouseLeave = () => setHighlightedIndexes(null)
                  }

                  internshipPeriod.push(<td {...props}> {content} </td>)
                }

                return (
                  <tr key={index.id + '_' + index} className='internship-line'>
                    <td>
                      <div className='maccs-internship-card-wrapper'>
                        <div className='quick-menu-container'>
                          <div className='flex-column h-100 jc-ctr'>
                            <AssistantMenu
                              internship={i}
                              onSelectedAssistant={() => setSelectedAssistant(i.assistant)}
                              onSelectedInternship={() => setInternshipInfo(i)}
                              onInternshipDelete={() => onDelete(i)}
                              onDuplicateInternship={() => onDuplicate(i)}
                            />
                          </div>
                        </div>
                        <MaccsInternshipCard internship={i} refresh={refresh} />
                        <div className='status-validation-wrapper'>
                          <MaccsStatesSelector
                            disabled={false}
                            internship={i}
                            onChange={state => onStateChange(i, state)}
                          />
                        </div>
                      </div>
                    </td>
                    {internshipPeriod}
                  </tr>
                )
              })
            )}
            {internships.length === 0 &&
              <tr>
                <td colSpan={COLUMNS_INFO_COUNT + DEFAULT_NUMBER_OF_WEEKS}>
                  {t('There is no internship to show for these dates.')}
                </td>
              </tr>}
          </tbody>
        </table>
      )}
      {loading && (
        <Loading size='4x' />
      )}
    </div>
  )
}

export default CalendarTable
